<template>
  <div>
    <MglGeojsonLayer
      :source-id="getSelectedAreaGeoJson.data.id"
      :source="getSelectedAreaGeoJson"
      :layer-id="getSelectedAreaPolygonLayer.id"
      :layer="getSelectedAreaPolygonLayer"
    />
    <MglGeojsonLayer
      :source-id="getSelectedAreaGeoJson.data.id"
      :source="getSelectedAreaGeoJson"
      :layer-id="getSelectedAreaPointsLayer.id"
      :layer="getSelectedAreaPointsLayer"
    />
    <MglGeojsonLayer
      :source-id="getSelectedAreaGeoJson.data.id"
      :source="getSelectedAreaGeoJson"
      :layer-id="getSelectedAreaLineLayer.id"
      :layer="getSelectedAreaLineLayer"
    />
  </div>
</template>

<script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "SelectedAreaLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/customAreasModule", [
      "getSelectedAreaGeoJson",
      "getSelectedAreaPolygonLayer",
      "getSelectedAreaPointsLayer",
      "getSelectedAreaLineLayer",
    ]),
  },
};
</script>
